import { render } from "./Emordle.vue?vue&type=template&id=224f371e"
import script from "./Emordle.vue?vue&type=script&lang=ts"
export * from "./Emordle.vue?vue&type=script&lang=ts"

import "./Emordle.vue?vue&type=style&index=0&id=224f371e&lang=scss"
script.render = render

export default script